import { Component, OnInit, ɵConsole, ViewChildren, ElementRef, Output, EventEmitter, Renderer2 } from '@angular/core';
import { SelectItem } from 'primeng/api/selectitem';
import { LazyLoadEvent } from 'primeng/api/lazyloadevent';
import { CalendarModule } from 'primeng/calendar';
import { PayOnEmailService } from '../service/pay-on-email.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PoeDataService } from '../service/poe-data.service';
import { Utility } from '../app.utility';
import { DatePipe } from '@angular/common';
import { Metadata } from '../models/request/Metadata';
import { MetadataResponse } from '../models/request/MetadataResponse';
import { MemcacheResponse } from '../models/request/MemcacheResponse';
import { CacheDataStorage } from '../models/request/CacheDataStorage';
import { MessageService } from '@arc/aureus';
import { HostListener } from "@angular/core";
import { DocumentTypes } from '../models/DocumentTypes';
import { DateModule } from '../util/DateModule';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']

})
export class DocumentsComponent implements OnInit {
  // @Output() nextPrevEvent = new EventEmitter<string>();
  @ViewChildren(CalendarModule) public cals: CalendarModule[];
  public invoiceValues: any[];
  public cols: any[];
  public isExpanded: boolean = false;
  public loading: boolean = false;
  public shortPayHeader: boolean = false;
  public rows: number = 10;
  public expandedRows = {};
  public virtualCars: any[];
  public temDataLength: number = 0;
  ShortPayReasons = [];
  shortpayTypes: SelectItem[];
  showShortPayBody = {};
  POEShortPayReasonCodeFormat = {};
  selectedRowData: any[];
  TotalDocumentAmount = 0;
  errorValidation = false;
  payment_date: Date;
  ValidationMessage: string;
  selectedShortpayTypes: string = 'Select Reason';
  private regex: RegExp = new RegExp("^\\d+(?:\\.\\d{0,2})?$");
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  public customerInfo: any = {};
  minDate: Date;
  isMobileCheckDevice: boolean = false;
  uniqueToken: any;
  customerId: number;
  primaryCustomerId: number;
  documentId: string[];
  tempResult: { "documentId": string; "invoiceNumber": string; "dueDate": string; "openBalance": string; "paidOnline": string; "totalDue": string; 'short_pay': string; "poNumber": string; "discountDate": string; "discountAmount": string; "billDate": string; "jobNumber": string; "projectNumber": string; }[];
  cacheData: MemcacheResponse;
  selectedAmount = 0;
  poeHeader: any;
  poeFooter: any;
  poeContact: any;
  bgColor: any;
  fontColour: any;
  CacheTest: any;
  colLength: number = 7;
  isPOEIncludeOverUnder: boolean = false;
  scrHeight: any;
  scrWidth: any;
  overPayShortPay: string;
  overNshortPay: boolean = false;
  accessToken: string;
  poeUsesDiscounts: string;
  poeAllowIGCCDiscounts: string;
  currencyType: string;
  currencyVal: string;
  usesOpenBalance: string;
  poeAllowStatementPayments: string;
  testVal: any;
  AchCount = 0;
  CCCount = 0;
  BothCount = 0;
  docListByPayMethod = [];
  showFlex: boolean;
  flexbileDocument = [];
  achDocuments = [];
  ccDocuments = [];
  enableFlexiblePay: boolean = false;
  flexbilecachemetaData: string;
  fDocumentTotal: any;
  NotmappedCount = 0;
  achLabel = "ACH";
  ccLabel = "CC";
  bothLabel = "BOTH";
  paymentMethodType = "universal";
  notMappedLabel = "notmapped";
  tAmount: number;

  constructor(private el: ElementRef,
    private renderer:Renderer2,
    private PayOnEmailService: PayOnEmailService,
    private router: Router,
    private route: ActivatedRoute,
    private PoeDataService: PoeDataService,
    public util: Utility,
    private datePipe: DatePipe,
    public messageService: MessageService,
    private dateModule: DateModule
  ) {

    this.uniqueToken = encodeURIComponent(this.route.snapshot.paramMap.get('uniquetoken'));
    this.GetAccessToken();
    this.dateModule = dateModule;
  }

  ngOnInit() {

    this.selectedRowData = [];
    this.cols = [
      { field: 'documentId', header: 'Document', label: 'Invoice', class: 'display-block' },
      { field: 'dueDate', header: 'Dates', label: 'Due Date', class: 'display-block' },
      { field: 'openBalance', header: 'Amounts', label: 'Open Balance', class: 'display-block' },
      { field: 'paidOnline', header: 'Paid Online', label: '', class: 'display-block' },
      { field: 'payAmount', header: 'Pay Amount', label: '', class: 'display-block' },
      { field: 'short_pay', header: 'Short Pay Reason', label: '', class: 'display-none' },
    ];

    this.getLookupInvoiceDetails();
    this.payment_date = this.dateModule.getDate();
    this.util.isMobileDevice();
    this.getScreenSize();
  }
  ngAfterViewInit() {
    let element = this.el.nativeElement.querySelector('.p-datatable-wrapper');
    this.renderer.removeStyle(element, 'height');
    this.renderer.setStyle(element, 'max-height', '300px');
  }
  GetAccessToken() {
    this.PoeDataService.GetAccessToken().subscribe(data => {
      this.accessToken = data;
    });
  }
  getLookupInvoiceDetails() {
    let POEIncludeOverUnder = "N";
    this.PoeDataService.getPoeMetaData().subscribe(data => {
      if (!this.util.isEmpty(data)) {
        let resultData = data as MetadataResponse;
        this.poeHeader = resultData.header;
        this.poeFooter = resultData.footer;
        this.bgColor = resultData.themeBackgroundColor;
        this.fontColour = resultData.themeForegroundColor;
        var parseVal = JSON.parse(resultData.metaData) as Metadata;
        this.customerInfo.customerName = resultData.accountName;
        this.customerInfo.customerAccountNumber = resultData.accountNumber;
        this.customerId = resultData.customerId;
        this.primaryCustomerId = resultData.primaryCustomerId;
        this.documentId = Object.values(parseVal.POE.DocumentId);
        this.poeContact = parseVal.POE.POEContact;
        this.poeUsesDiscounts = parseVal.POE.POEUsesDiscounts;
        this.poeAllowIGCCDiscounts = parseVal.POE.POEAllowIGCCDiscounts;
        this.currencyVal = parseVal.PAC.Currency;
        this.usesOpenBalance = parseVal.POE.UsesOpenBalance;
        this.poeAllowStatementPayments = parseVal.POE.POEAllowStatementPayments;
        if (parseVal.PAC.Currency == "CAD") {
          this.currencyType = "(CAD) ";
        }

        // flexible payment flow
        if (parseVal.POE.UsePOETemplateConvenienceFees === 'Y' && parseVal.POE.FlexibleConvenienceFee === 'Y') {
          this.enableFlexiblePay = true;
        }

        POEIncludeOverUnder = parseVal.POE.POEIncludeOverUnder;
        if (POEIncludeOverUnder == "Y" || POEIncludeOverUnder == "y")
          this.isPOEIncludeOverUnder = true;

        if (parseVal.POE.POEOverUnderRule == "=")
          this.overNshortPay = true;
        else
          this.overPayShortPay = parseVal.POE.POEOverUnderRule;
        //Reason Start
        if (this.isPOEIncludeOverUnder) {
          this.POEShortPayReasonCodeFormat = parseVal.POE.POEShortPayReasonCodeFormat;
          if (parseVal.POE.POEShortPayReasons == undefined || parseVal.POE.POEShortPayReasons.length == 0) {
            this.ShortPayReasons = ['Damaged Product', 'Partial Shipment Received', 'Incorrect Amount'];
          }
          else {
            this.ShortPayReasons = Object.values(parseVal.POE.POEShortPayReasons);
          }
          this.shortpayTypes = [];
          if (this.POEShortPayReasonCodeFormat == 'FixedList') {
            this.ShortPayReasons.forEach((shortpayReason) => {
              this.shortpayTypes.push({ label: shortpayReason, value: shortpayReason });
            });
          } else if (this.POEShortPayReasonCodeFormat == 'FreeForm') {
            this.shortpayTypes.push({ label: 'Others', value: 'Others' });
          } else if (this.POEShortPayReasonCodeFormat == 'ComboList') {
            this.ShortPayReasons.forEach((shortpayReason) => {
              this.shortpayTypes.push({ label: shortpayReason, value: shortpayReason });
            });
            this.shortpayTypes.push({ label: 'Others', value: 'Others' });
          }
        }
        //Reason End 
        this.PoeDataService.invoicesData.subscribe(data2 => {
          let tempResult1 = data2 as any;
          let tempResult = tempResult1[0].foundDocuments;
          tempResult.forEach((row, index) => {
            let payAmount = 0;
            if(this.usesOpenBalance == "Y"){
              if(this.poeAllowStatementPayments == "Y" && row.itemType == "S"){
                payAmount = ((row.totalDue) - (row.paidOnline)); 
              }
              else if(this.poeAllowStatementPayments == "N" && row.itemType == "S"){
                payAmount = (0 - (row.paidOnline));
              }
              else{
                payAmount = ((row.openBalance) - (row.paidOnline));
              }
            }
            if(this.usesOpenBalance != "Y"){
              payAmount = ((row.totalDue) - (row.paidOnline)); 
            }
            if (row.openBalance >= 0) {
              if (payAmount < 0) {
                payAmount = 0;
              }
            }
            tempResult[index].payAmount = payAmount
            tempResult[index].showPay = false;
            tempResult[index].shortPayreason = "";
            tempResult[index].shortPayText = "";
            tempResult[index].checkDetails = "";
            tempResult[index].actualAmount = tempResult[index].payAmount;
            tempResult[index].checkboxBgClr = '';
            let documentTypes = DocumentTypes[row.itemType];
            if (row.openBalance < 0) {
              documentTypes = DocumentTypes['M'];
            }
            tempResult[index].documentTypeName = documentTypes;
            // //flexbile paymennnnnt
            if ((tempResult[index].allowCheckingAccounts === 'true') && (tempResult[index].allowCreditCards === 'false')) {
              tempResult[index].flexbilePayType = this.achLabel;
            } else if ((tempResult[index].allowCheckingAccounts === 'true') && (tempResult[index].allowCreditCards === 'realtime')) {
              tempResult[index].flexbilePayType = this.bothLabel;
            } else if ((tempResult[index].allowCheckingAccounts === 'false') && (tempResult[index].allowCreditCards === 'realtime')) {
              tempResult[index].flexbilePayType = this.ccLabel;
            } else if ((tempResult[index].allowCheckingAccounts === 'false') && (tempResult[index].allowCreditCards === 'false')) {
              tempResult[index].flexbilePayType = this.notMappedLabel;
            }

          });
          this.invoiceValues = tempResult;
          this.PayOnEmailService.GetMemcache("documentmetadata", this.accessToken).subscribe(data2 => {
            if (data2.status === 200) {
              debugger;
              this.cacheData = data2.body as MemcacheResponse;
              if (!this.cacheData.memcachedValue.isNull) {
                let cacheDataStorage: CacheDataStorage = JSON.parse(this.cacheData.memcachedValue.value) as CacheDataStorage;
                let cacheDatas = JSON.parse(cacheDataStorage.Documents.replace(/\\/g, ""));
                
                if (cacheDatas) {
                  tempResult.forEach((row, index) => {
                    for (var key in cacheDatas) {
                      if (cacheDatas[key]["documentId"] == row.documentId) {
                        if (cacheDatas[key]['payAmount'] != row.totalDue) {
                          this.invoiceValues[index].payAmount = cacheDatas[key]['payAmount'];
                          this.invoiceValues[index].showPay = cacheDatas[key]['showPay'];
                          if (this.invoiceValues[index].showPay) {
                            this.shortPayHeader = true;
                          }
                          this.invoiceValues[index].shortPayreason = cacheDatas[key]['shortPayreason'];
                          this.invoiceValues[index].shortPayText = cacheDatas[key]['shortPayText'];
                        }
                      }
                    }
                  });
                  this.selectedRows = cacheDatas;
                }
              }
            }
          });

          //cachedata
          this.invoiceValues.length < this.rows ? this.temDataLength = this.invoiceValues.length : this.temDataLength = this.rows;
          this.invoiceValues.forEach((row, index) => {
            this.TotalDocumentAmount += (row.payAmount);
          });
          this.getScreenSize();

        });
      }
    });
  }

  checkDateFormate(date: Date) {
    return this.util.dateFormate(date);
  }

  currencyToNumber(value: string): number {
    const regex: RegExp = /[\$\,]/g;
    return +value.replace(regex, '');
  }

  numberToCurrency(value: number): string {
    let formattedValue = `${value}`;
    const valueArray = [];
    if (formattedValue.length > 2) {
      while (formattedValue.length > 0) {
        valueArray.unshift(formattedValue.slice(-3));
        formattedValue = formattedValue.slice(0, -3);
      }
      return `$${valueArray.join(',')}.00`;
    }
    return `${formattedValue}`;
  }

  formatNumber(num) {
    return this.util.formatNumber(num);
  }
  FormatNumberwoCurrency(num) {
    return this.util.FormatNumberWoCurrency(num);
  }
  private _selectedRows: any;
  public get selectedRows(): any {
    return this._selectedRows;
  }

  public set selectedRows(value: any) {
    if (value !== this._selectedRows) {
      this._selectedRows = value;
      this.selectedAmount = 0;
      value.forEach(row => {
        this.selectedAmount += (row.payAmount);
      });
    }
  }

  onClick() {
    if (this.selectedRows) {
      if (this.selectedRows.length === this.invoiceValues.length) {
        this.selectedRows = [];
      } else {
        this.selectedRows = this.invoiceValues;
      }
    } else {
      this.selectedRows = this.invoiceValues;
    }
  }

  expandAll() {
    if (!this.isExpanded) {
      this.invoiceValues.forEach(data => {
        this.expandedRows[data.documentId] = 1;
      })
    } else {
      this.expandedRows = {};
    }
    this.isExpanded = !this.isExpanded;
  }

  onRowExpand() {
    if (Object.keys(this.expandedRows).length === this.temDataLength) {
      this.isExpanded = true;
    }
  }

  currency: string = 'USD';

  localStringToNumber(s) {
    return Number(String(s).replace(/[^0-9.-]+/g, ""));
  }

  onBlurMethod(event: any, actualAmount: any, itemType: any, openBalance: any) {
    debugger;
    var value = event.target.value;
    if (itemType == "M" || openBalance < 0) {
      event.target.value = this.CheckNagativeValue(value);
    } else {
      event.target.value = this.CheckZeroValue(value);
    }
  }

  isPositive(number) {
    if (number > 0) {
      return true;
    }
    if (number < 0) {
      return false;
    }
    if (1 / number === Number.POSITIVE_INFINITY) {
      return true;
    }
    return false;
  }
  newValue = '';
  onChange(event: any, actualValue: any, itemType: any, openBalance: any) {
    debugger;
    let isValidDocument = true;
    this.shortPayHeader = false;
    if (itemType == "M" || openBalance < 0) {
      this.newValue = this.CheckNagativeValue(event.target.value);
      if (actualValue <= this.currencyToNumber(this.newValue)) {
        this.invoiceValues[event.target.id].payAmount = this.currencyToNumber(this.newValue);
      } else {
        this.ValidationMessage = 'You have chosen to take more credit than is available for this item. Please review the payment amount to make sure you have entered it correctly';
        isValidDocument = false;
        event.target.value = this.FormatNumberwoCurrency(actualValue);
        this.newValue = event.target.value;
        if (!isValidDocument) {
          this.openMessageNavigate();
        }
      }
    } else {
      this.newValue = this.CheckZeroValue(event.target.value);
    }
    if (this.currencyToNumber(this.newValue) > 0 || (((itemType == "M" || openBalance < 0)) && this.currencyToNumber(this.newValue) != 0)) {
      if (actualValue > this.currencyToNumber(this.newValue) || actualValue < this.currencyToNumber(this.newValue)) {
        if (this.isPOEIncludeOverUnder)
          this.invoiceValues[event.target.id].showPay = true;
      } else {
        if (this.isPOEIncludeOverUnder) {
          this.invoiceValues[event.target.id].showPay = false;
          this.invoiceValues[event.target.id].shortPayreason = '';
          this.invoiceValues[event.target.id].shortPayText = '';
        }
      }
    } else {
      if (this.isPOEIncludeOverUnder) {
        this.invoiceValues[event.target.id].showPay = false;
        this.invoiceValues[event.target.id].shortPayreason = '';
        this.invoiceValues[event.target.id].shortPayText = '';
      }
    }
    let showPaycount = 0;
    this.invoiceValues.forEach((row, index) => {
      showPaycount += (row.showPay);
    });
    if (showPaycount > 0) {
      this.shortPayHeader = true;
    }
    this.invoiceValues[event.target.id].payAmount = this.currencyToNumber(this.newValue);
    this.onChangeSumValue();
    this.getScreenSize();
  };

  CheckZeroValue(value) {
    var checkPositive = this.isPositive(Math.sign(this.currencyToNumber(value)));
    if (checkPositive) {
      return value;
    } else {
      var tVlaue = '0.00';
      return tVlaue;
    }
  }
  CheckNagativeValue(value) {
    var checkPositive = this.isNagative(Math.sign(this.currencyToNumber(value)));
    if (checkPositive) {
      return value;
    } else {
    }
    var tVlaue = '0.00';
    return tVlaue;
  }
  isNagative(number) {
    if (number > 0) {
      return false;
    }
    if (number < 0) {
      return true;
    }
    if (1 / number === Number.NEGATIVE_INFINITY) {
      return true;
    }
    return false;
  }
  onChangeSumValue() {
    this.selectedAmount = 0;
    if (!this.cacheData.memcachedValue.isNull) {
      this.invoiceValues.forEach((row, index) => {
        let selected = this.selectedRows;
        for (var key in selected) {
          if (selected[key]["documentId"] == row.documentId) {
            this.selectedRows[key]["payAmount"] = row.payAmount;
            this.selectedRows[key]["showPay"] = row.showPay;
          }
        }
      });
    }
    if (this.selectedRows != undefined) {
      this.selectedRows.forEach(row => {
        this.selectedAmount += (row.payAmount);
      });
    }
  }

  onRowCollapse() {
    if (Object.keys(this.expandedRows).length === 0) {
      this.isExpanded = false;
    }
  }

  onPage(event: any) {
    this.temDataLength = this.invoiceValues.slice(event.first, event.first + 10).length;
    this.isExpanded = false;
    this.expandedRows = {};
  }

  loadDataOnScroll(event: LazyLoadEvent) {
    this.loading = true;
    setTimeout(() => {
      if (event.first === 249980) {
        this.virtualCars = this.loadChunk(event.first, 20);
      } else {
        this.virtualCars = this.loadChunk(event.first, event.rows);
      }
      this.loading = false;
    }, 250);
  }
  loadChunk(first: number, arg1: number): any {
    throw new Error("Method not implemented.");
  }

  flexbilePaymentFunc(SelectItem) {
    this.docListByPayMethod['C'] = SelectItem.filter(x => x.allowCreditCards === 'realtime');
    this.docListByPayMethod['A'] = SelectItem.filter(x => x.allowCheckingAccounts === 'true');
    return this.docListByPayMethod;
  }

  payflexbile(val) {

    let flexDoc: any;
    flexDoc = Object.assign({}, this.flexbileDocument);

    if (val === this.achLabel) {
      this.fDocumentTotal = flexDoc.A.length;
      this.flexbilecachemetaData = JSON.stringify(flexDoc.A).replace(/"/g, '\\"');
      let atotal = 0;
      flexDoc.A.forEach((row, index) => {
        atotal += (row.payAmount);
      });
      if (atotal <= 0) {
        this.showFlex = true;
        this.ValidationMessage = 'The total payment amount you’ve specified is a negative amount or 0. Please review your payment amounts to ensure that you are making a positive payment.';
        this.openMessageNavigate();
        return false;
      } else {
        this.showFlex = false;
        this.loadPacfunc(this.achLabel, atotal);
      }

    }
    if (val === this.ccLabel) {
      this.fDocumentTotal = flexDoc.C.length;
      this.flexbilecachemetaData = JSON.stringify(flexDoc.C).replace(/"/g, '\\"');
      let ctotal = 0;
      flexDoc.C.forEach((row, index) => {
        ctotal += (row.payAmount);
      });
      if (ctotal <= 0) {
        this.showFlex = true;
        this.ValidationMessage = 'The total payment amount you’ve specified is a negative amount or 0. Please review your payment amounts to ensure that you are making a positive payment.';
        this.openMessageNavigate();
        return false;
      } else {
        this.showFlex = false;
        this.loadPacfunc(this.ccLabel, ctotal);
      }
    }

  }

  loadPac() {
    let valid = true;
    let selectedResult = this.selectedAmount;
    let showPayreasonValue = true;
    let showPayreasonTextValue = true;
    let isPayAmountEmpty = false;

    if (this.selectedRows != undefined) {
      this.invoiceValues.forEach((row, index) => {
        let selected = this.selectedRows;
        for (var key in selected) {
          if (selected[key]["documentId"] == row.documentId) {
            this.selectedRows[key]["shortPayText"] = row.shortPayText;
            this.selectedRows[key]["shortPayreason"] = row.shortPayreason;
          }
        }
      });

      this.selectedRows.forEach((row, index) => {
        if (this.selectedRows[index].payAmount == 0) {
          isPayAmountEmpty = true;
          return;
        }
        if (this.selectedRows[index].showPay) {
          if (this.selectedRows[index].shortPayreason == "") {
            showPayreasonValue = false;
          } else {
            if (this.selectedRows[index].shortPayreason != '' && this.selectedRows[index].shortPayreason == "Others") {
              if (this.selectedRows[index].shortPayText.trim().length == 0) {
                showPayreasonTextValue = false;
              }
            }
          }
        }
      });
    }

    let overNShortPay;
    if (this.selectedRows != undefined)
      overNShortPay = this.CheckOverPayShortPay();
    if ((this.selectedRows || "").length == 0) {
      this.ValidationMessage = 'Please select document to proceed the payment';
      valid = false;
    }
    else if (this.payment_date == undefined) {
      this.ValidationMessage = 'Please select payment date to proceed the payment';
      valid = false;
    }
    else if (isPayAmountEmpty) {
      this.ValidationMessage = 'Please enter pay amount to proceed the payment';
      valid = false;
    }
    else if (!showPayreasonValue) {
      this.ValidationMessage = 'Please select reason to proceed the payment';
      valid = false;
    }
    else if (!showPayreasonTextValue) {
      this.ValidationMessage = 'Please enter reason to proceed the payment';
      valid = false;
    }
    else if (overNShortPay) {
      this.ValidationMessage = overNShortPay;
      valid = false;
    } else if (this.selectedAmount <= 0) {
      this.ValidationMessage = 'The total payment amount you’ve specified is a negative amount or 0. Please review your payment amounts to ensure that you are making a positive payment.';
      valid = false;
    } else {
      valid = true;
    }


    if (!valid) {
      this.openMessageNavigate();
    }
    else {
      if (this.enableFlexiblePay) {
        let isValidDocument = true;

        if (this.selectedRows != undefined) {
          this.AchCount = 0; this.CCCount = 0; this.BothCount = 0; this.NotmappedCount = 0;
          this.selectedRows.forEach((row, index) => {
            if (this.selectedRows[index].flexbilePayType === this.achLabel) {
              this.AchCount += 1;
            } else if (this.selectedRows[index].flexbilePayType === this.ccLabel) {
              this.CCCount += 1;
            } else if (this.selectedRows[index].flexbilePayType === this.bothLabel) {
              this.BothCount += 1;
            } else if (this.selectedRows[index].flexbilePayType === this.notMappedLabel) {
              this.NotmappedCount += 1;
            }
          });
        }

        if ((this.NotmappedCount == this.selectedRows.length) && (this.AchCount == 0) && (this.CCCount == 0) && (this.BothCount == 0)) {
          // this.ValidationMessage = 'No payment option set, please contact support to process payment';
          // isValidDocument = false;
          // if (!isValidDocument) {
          //   this.openMessageNavigate();
          // }
          // return false;

          this.loadPacfunc('', 0);

        } else {
          this.tAmount = 0;
          let documentList = this.documentwithType(this.selectedRows);
          this.fDocumentTotal = documentList.length;
          documentList.forEach(row => { this.tAmount += (row.payAmount); });

          if ((this.AchCount > 0) && (this.CCCount == 0) && (this.BothCount == 0) && (this.NotmappedCount >= 0)) {

            this.flexbilecachemetaData = JSON.stringify(documentList).replace(/"/g, '\\"');
            this.loadPacfunc(this.achLabel, this.tAmount);

          } else if ((this.CCCount > 0) && (this.AchCount == 0) && (this.BothCount == 0) && (this.NotmappedCount >= 0)) {

            this.flexbilecachemetaData = JSON.stringify(documentList).replace(/"/g, '\\"');
            this.loadPacfunc(this.ccLabel, this.tAmount);

          } else if ((this.BothCount > 0) && (this.AchCount == 0) && (this.CCCount == 0) && (this.NotmappedCount >= 0)) {

            this.flexbilecachemetaData = JSON.stringify(documentList).replace(/"/g, '\\"');
            this.loadPacfunc(this.bothLabel, this.tAmount);

          } else if ((this.BothCount > 0) && (this.AchCount > 0) && (this.CCCount == 0)) {

            this.flexbilecachemetaData = JSON.stringify(documentList).replace(/"/g, '\\"');
            this.loadPacfunc(this.achLabel, this.tAmount);

          } else if ((this.BothCount > 0) && (this.AchCount == 0) && (this.CCCount > 0)) {

            this.flexbilecachemetaData = JSON.stringify(documentList).replace(/"/g, '\\"');
            this.loadPacfunc(this.ccLabel, this.tAmount);

          } else {

            this.flexbileDocument = this.flexbilePaymentFunc(documentList);
            console.log(this.flexbileDocument);
            this.showFlex = true;
          }
        }

      } else {
        this.loadPacfunc('universal', 0);
      }
    }
  }

  documentwithType(selectedItems) {
    return selectedItems.filter(x => x.flexbilePayType != this.notMappedLabel);
  }

  loadPacfunc(type, pamount: any) {

    let cachemetaData: string = JSON.stringify(this.selectedRows).replace(/"/g, '\\"');
    let payDate = this.checkDateFormate(this.dateModule.getDate());
    let Cache = {
      "AccountName": this.customerInfo.customerName,
      "AccountNumber": this.customerInfo.customerAccountNumber,
      "TotalDocuments": this.selectedRows.length,
      "TotalBalance": this.selectedAmount,
      "PaymentDate": payDate,
      "Documents": cachemetaData,
      "Header": this.poeHeader,
      "Footer": this.poeFooter,
      "BgColor": this.bgColor,
      "FontColor": this.fontColour,
      "PoeContact": this.poeContact,
      "PoeUsesDiscounts": this.poeUsesDiscounts,
      "PoeAllowIGCCDiscounts": this.poeAllowIGCCDiscounts,
      "Currency": this.currencyVal,
      "EnableFlexbilePay": this.enableFlexiblePay,
      "flexDocuments": this.flexbilecachemetaData,
      "flexPaymentmethodType": type,
      "flexTotalAmount": pamount,
      "flextTotalDocument": this.fDocumentTotal,
      "UsesOpenBalance" : this.usesOpenBalance,
      "POEAllowStatementPayments" : this.poeAllowStatementPayments
    };
    let cacheString: string = JSON.stringify(Cache);
    this.PayOnEmailService.SetMemcache("documentmetadata", cacheString, this.accessToken).subscribe(data2 => {
      if (data2.status === 200) {
        this.router.navigate(['pac', decodeURIComponent(this.uniqueToken)]);
      }
    },
      error => {
        console.log(`Setmemcache: ${error}`);
      });
  }

  CheckOverPayShortPay(): string {
    let statusMessage: string;
    if (this.overPayShortPay) {
      let selectedActualAmount: number = 0;
      this.selectedRows.forEach((row, index) => {
        selectedActualAmount += row.actualAmount;
        if (row.openBalance < 0) {
          if (this.overPayShortPay == ">=") {
            if (row.actualAmount < row.payAmount)
              statusMessage = "You are only allowed to pay your bill in full or greater. Any amount that is less than the amount due is not accepted.";
          }
        } else if (this.overPayShortPay == "<=") {
          if (row.actualAmount < row.payAmount)
            statusMessage = "You are only allowed to pay your bill in full. Any amount that is greater than the amount due is not accepted.";
        } else if (this.overPayShortPay == ">=") {
          if (row.actualAmount > row.payAmount)
            statusMessage = "You are only allowed to pay your bill in full or greater. Any amount that is less than the amount due is not accepted.";
        }
      });
      // let tda = selectedActualAmount;
      // let sa = this.selectedAmount;
      // if (this.overPayShortPay == "<=") {
      //   if (sa > tda)
      //     statusMessage = "You are only allowed to pay your bill in full. Any amount that is greater than the amount due is not accepted.";
      // }
      // else if (this.overPayShortPay == ">=") {
      //   if (sa < tda)
      //     statusMessage = "You are only allowed to pay your bill in full or greater. Any amount that is less than the amount due is not accepted.";
      // }

    }
    return statusMessage;
  }
  openMessageNavigate() {
    this.messageService.open(this.ValidationMessage,
      null,
      {
        channel: 'auth',
        dismissOthers: true,
        severity: 'warning',
        duration: 10000,
      },
    );
  }


  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    let colLengnIncrease = false;
    if (this.invoiceValues != undefined) {
      this.invoiceValues.forEach((row, index) => {
        if (this.invoiceValues[index].showPay) {
          colLengnIncrease = true;
        }
      });
    }
    if (this.scrWidth > 648 && 901 > this.scrWidth) {
      this.colLength = 6;
      if (colLengnIncrease) {
        this.colLength = 7;
      }
    } else {
      if (colLengnIncrease) {
        this.colLength = 8;
      } else {
        this.colLength = 7;
      }
    }
  }
}





